export const VALID_PASSWORD_LENGTH = 12;
